import { z } from 'zod';
import { c } from '../../contract';
import { shippingAddress } from '../../types/ShippingAddress';

export const bookShopRouter = c.router(
  {
    createPaymentIntent: {
      summary: 'Creates a new Stripe payment intent and a new draft order, sent by the app client.',
      method: 'POST',
      path: '/payment-intents',
      body: z.object({
        productId: z.coerce.number(),
        productTitle: z.string().optional(),
        variantId: z.string(),
        shippingVariantId: z.string().optional(),
        paymentMethodId: z.string().optional(),
        currencyCode: z.string().optional(),
      }),
      responses: {
        200: c.type<{ success: boolean; paymentIntent: string; orderId: string }>(),
        500: c.type<{ success: false }>(),
        400: c.type<{ success: false }>(),
        404: c.type<{ success: false }>(),
      },
    },

    setOrderAsPaid: {
      summary: 'Changes the Shopify order status to PAID, sent by the app client',
      method: 'POST',
      path: '/orders',
      body: z.object({
        paymentIntentId: z.string(),
        address: shippingAddress,
        orderId: z.string(),
      }),
      responses: {
        200: c.type<{ success: boolean }>(),
        500: c.type<{ success: false }>(),
      },
    },

    // Triggered via Google Cloud Scheduler everyday 8AM.
    scheduledIngramDispatchAll: {
      summary:
        'Fetches all pending orders from Shopify and triggers the Ingram dispatch process so the books are printed and shipped',
      method: 'POST',
      path: '/scheduled-ingram-dispatch',
      body: z.undefined().or(
        z.object({
          ingramRegion: z.enum(['US', 'EU']),
          shopifyStoreRegion: z.enum(['US', 'EU']).default('US'),
        }),
      ),
      responses: {
        200: c.type<{ success: boolean }>(),
        500: c.type<{ success: false }>(),
      },
    },

    // Triggered via Google Cloud Scheduler every hour.
    scheduledIngramCheckFulfilled: {
      summary: 'Checks Ingram for fulfilled orders and updates the Shopify orders accordingly',
      method: 'POST',
      path: '/scheduled-ingram-check-fulfilled',
      body: z.undefined().or(
        z.object({
          ingramRegion: z.enum(['US', 'EU']),
        }),
      ),
      responses: {
        200: c.type<{ success: boolean }>(),
        500: c.type<{ success: false }>(),
      },
    },

    // Triggered via Google Cloud Scheduler every hour.
    scheduledIngramCheckShippingNotifications: {
      summary: 'Checks Ingram for shipping notifications and updates the Shopify orders accordingly',
      method: 'POST',
      path: '/scheduled-ingram-check-shipping-notifications',
      body: z.undefined().or(
        z.object({
          ingramRegion: z.enum(['US', 'EU']),
        }),
      ),
      responses: {
        200: c.type<{ success: boolean }>(),
        500: c.type<{ success: false }>(),
      },
    },

    getDoubleDashOfferRecommendation: {
      summary: 'Returns a Double Dash offer recommendation for the given user',
      method: 'GET',
      path: '/double-dash-offer/recommendations',
      responses: {
        200: c.type<{ recommendations: string[] }>(),
      },
    },
  },
  { pathPrefix: '/book-shop' },
);
